import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { MRT_SortingState } from "material-react-table";
import { RootState } from "@/components/state/store";
import { getDefaultSort } from "@/components/tables/genericCrudTable.utils";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

interface UseTableSortingParams {
  entity: string;
  entityAdapter?: EntityAdapter;
}

export function useTableSorting({
  entity,
  entityAdapter,
}: UseTableSortingParams) {
  const globalTableConfig: any =
    useSelector((state: RootState | any) => state.tableConfig) ?? {};

  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnSorting, setColumnSorting] = useState<string>("");
  const [sortingReady, setSortingReady] = useState(false);
  const isInitialSortRef = useRef(true);

  useEffect(() => {
    let descending; // conversion to boolean for tableState
    let sort; // sortingValue for URL
    let tableSort; // sortingValue for tableState

    const entityConfig = globalTableConfig[entity];
    if (entityConfig?.sorting) {
      sort = entityConfig.sorting.queryParameter;
      tableSort = entityConfig.sorting.table.id;
      descending = entityConfig.sorting.table.desc;
    } else {
      const defaultSort = getDefaultSort(entityAdapter);
      sort = defaultSort.sort;
      tableSort = defaultSort.tableSort;
      descending = defaultSort.descending;
    }

    setColumnSorting(sort);
    setSorting([{ id: tableSort, desc: descending }]);
    setSortingReady(true);
  }, []);

  return {
    sorting,
    setSorting,
    columnSorting,
    setColumnSorting,
    sortingReady,
    isInitialSortRef,
  };
}
